exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".linkedinIcon {\n  fill: #0077b7;\n}\n", ""]);
